var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNoAccounts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 42,
    fill: "url(#paint0_linear_91_9030)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.375 31.875H56.25V29.75C56.25 28.0592 55.5784 26.4377 54.3828 25.2422C53.1873 24.0467 51.5658 23.375 49.875 23.375H28.625C26.9342 23.375 25.3127 24.0467 24.1172 25.2422C22.9217 26.4377 22.25 28.0592 22.25 29.75V29.75V55.25C22.25 56.9408 22.9217 58.5623 24.1172 59.7578C25.3127 60.9534 26.9342 61.625 28.625 61.625H58.375C60.0658 61.625 61.6873 60.9534 62.8828 59.7578C64.0784 58.5623 64.75 56.9408 64.75 55.25V38.25C64.75 36.5592 64.0784 34.9377 62.8828 33.7422C61.6873 32.5467 60.0658 31.875 58.375 31.875ZM28.625 27.625H49.875C50.4386 27.625 50.9791 27.8489 51.3776 28.2474C51.7761 28.6459 52 29.1864 52 29.75V31.875H28.625C28.0614 31.875 27.5209 31.6511 27.1224 31.2526C26.7239 30.8541 26.5 30.3136 26.5 29.75C26.5 29.1864 26.7239 28.6459 27.1224 28.2474C27.5209 27.8489 28.0614 27.625 28.625 27.625V27.625ZM60.5 48.875H58.375C57.8114 48.875 57.2709 48.6511 56.8724 48.2526C56.4739 47.8541 56.25 47.3136 56.25 46.75C56.25 46.1864 56.4739 45.6459 56.8724 45.2474C57.2709 44.8489 57.8114 44.625 58.375 44.625H60.5V48.875ZM60.5 40.375H58.375C56.6842 40.375 55.0627 41.0466 53.8672 42.2422C52.6716 43.4377 52 45.0592 52 46.75C52 48.4408 52.6716 50.0623 53.8672 51.2578C55.0627 52.4534 56.6842 53.125 58.375 53.125H60.5V55.25C60.5 55.8136 60.2761 56.3541 59.8776 56.7526C59.4791 57.1511 58.9386 57.375 58.375 57.375H28.625C28.0614 57.375 27.5209 57.1511 27.1224 56.7526C26.7239 56.3541 26.5 55.8136 26.5 55.25V35.7637C27.1827 36.0039 27.9013 36.1261 28.625 36.125H58.375C58.9386 36.125 59.4791 36.3489 59.8776 36.7474C60.2761 37.1459 60.5 37.6864 60.5 38.25V40.375Z",
    fill: "#F5D016"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_91_9030",
    x1: 42,
    y1: 0,
    x2: 42,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B51F07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D1304"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoAccounts);
export default __webpack_public_path__ + "static/media/icon_no_accounts.59b5e27272990fa3d261dee935382322.svg";
export { ForwardRef as ReactComponent };